{
	"captcha-valid": "Nauðsynlegt",
	"companyDebitForm": "Beiðni um afgreiðslu sendingar",
	"name-length": "Nafn getur aðeins verið 12 stafir að lengd",
	"countLetters": "Pósturinn óskast talinn við póstlagningu",
	"email": "Netfang",
	"email-format": "Verður að vera leyfilegt netfang",
	"input": "Skráðu fjölda bréfa sem á að senda",
	"validateMultiple": "Skylda að fylla út minnst einn",
	"name": "Nafn",
	"nameOfCompany": "Nafn fyrirtækis",
	"numberOfEuropeanLetters": "Fjöldi bréfa til Evrópu",
	"numberOfLettersOutsideEurope": "Fjöldi bréfa utan Evrópu",
	"numberOfRegularLetters": "Fjöldi almennra bréfa",
	"numberOfRegisteredLetters": "Fjöldi rekjanlegra bréfa",
	"numberslength": "Ekki lengra en 5 tölustafir",
	"onlyNumbers": "Aðeins tölur leyfilegar",
	"greaterThanZero": "Gildi þarf að vera hærra en 0",
	"reference": "Tilvísun",
	"register": "Senda",
	"required": "Skylda að fylla út",
	"socialId": "Kennitala",
	"socialIdMinimum": "Kennitala er að lágmarki 9 stafir",
	"socialIdMax": "Kennitala er að hámarki 10 stafir",
	"socialIdRequired": "Skylda að fylla út",
	"socialIdValid": "Ekki gild kennitala  – vinsamlega hafið samband við Póstinn í síma 5801300 eða sendið tölvupóst á fjarstyring@postur.is "
}
